export default "__VITE_PUBLIC_ASSET__7c368b7f__"